import { render } from "./property-alerts.vue?vue&type=template&id=af2e5954"
import script from "./property-alerts.vue?vue&type=script&lang=js"
export * from "./property-alerts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__